<template>
  <div>
    <socialMedia :class="{movedUp : newsMenuOpened}" />
    <newsMenu @BarStatusChanged="barStatusChanged" />
    <VFooter v-if="$isMobile()" />
  </div>
</template>

<script>
import newsMenu from "./news/newsMenu";
import socialMedia from "./socialMedia";
import VFooter from "./footer";

export default {
  components: {
    newsMenu,
    socialMedia,
    VFooter
  },
  data: function() {
    return {
      newsMenuOpened: false
    };
  },
  methods: {
    barStatusChanged: function(shownOrHidden) {
      this.newsMenuOpened = shownOrHidden;
    }
  }
};
</script>

<style>
</style>